import Typography from "@portal/components/atoms/v2/typography";
import { ButtonOptionSelector } from "@portal/components/atoms/buttonOptionSelector";
import { TextResources } from "@portal/assets/text/TextResources";
import { FC } from "react";
import { IYearlyIncreaseProps } from "./types";
import { TextLine } from "@portal/components/atoms/v2/textLine";

const options = ["Ingen", "10%", "20%", "30%"];

const getPercentage = (i: number) => {
  switch (i) {
    case 0:
      return 0;
    case 1:
      return 10;
    case 2:
      return 20;
    case 3:
      return 30;
    default:
      return 0;
  }
};

export const getYearlyIncreaseIndex = (percent: number) => {
  switch (percent) {
    case 0:
      return 0;
    case 10:
      return 1;
    case 20:
      return 2;
    case 30:
      return 3;
    default:
      return 0;
  }
};

const YearlyIncrease: FC<IYearlyIncreaseProps> = ({ handleChange, selectedItem }) => {
  const internalHandleChange = (i: number) => {
    handleChange(i, getPercentage(i));
  };

  return (
    <>
      <div className="flex flex-col mt-2">
        <div className="flex flex-col">
          <Typography variant="Lead">{TextResources.AGREEMENT_YEARLY_INCREASE}</Typography>
          <TextLine />
        </div>
        <Typography variant="Body">{TextResources.AGREEMENT_YEARLY_INCREASE_TEXT}</Typography>
      </div>
      <div className="mt-2">
        <ButtonOptionSelector
          options={options.map((o, i) => (
            <Typography key={i}>{o}</Typography>
          ))}
          selectedItem={selectedItem}
          handleChange={internalHandleChange}
        />
      </div>
    </>
  );
};

export default YearlyIncrease;
